//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import account from './components/account.vue';
export default {
  components: {
    account,
  },
  data() {
    return {
      redirectUrl: '',
      storage: true,
      fromUrl: '',
      isCheckMode: false,
    };
  },
  computed: {},
  watch: {},
  async mounted() {
    const { action } = this.$route.query;
    this.fromUrl = this.$route.query.from_url;

    // 登录态检测模式
    if (action === 'check' && this.fromUrl) {
      this.isCheckMode = true;
      await this.checkLoginStatus();
      return;
    }

    const storage = Number(this.$route.query.storage);
    console.log('------storage------', storage);
    console.log('------fromUrl------', this.fromUrl);
    if (storage === 0) {
      this.storage = false;
    } else {
      this.storage = true;
    }

    console.log('------this.storage------', this.storage);
  },
  methods: {
    // 发送消息给父窗口（兼容 iframe 和 window.open）
    postMessageToOpener(data) {
      const target = window.opener || parent;
      if (target && target !== window) {
        target.postMessage(data, this.fromUrl);
      }
    },
    async checkLoginStatus() {
      const token = this.$cookies.get('saas_token');

      if (!token) {
        // 无 token，返回未登录状态
        this.postMessageToOpener({ logged_in: false });
        return;
      }

      try {
        // 验证 token 有效性并获取用户信息
        const userInfo = await this.$request({
          url: this.$api.getUserinfo,
          data: {},
          tmpToken: token,
        });
        const tenantInfo = await this.$request({
          url: this.$api.getTenantInfo,
          data: {},
          tmpToken: token,
        });

        // 返回已登录状态和用户信息
        this.postMessageToOpener({
          logged_in: true,
          saas_token: token,
          user_info: userInfo,
          tenant_info: tenantInfo,
        });
      } catch (e) {
        // token 无效，返回未登录状态
        console.error('Token validation failed:', e);
        this.postMessageToOpener({ logged_in: false });
      }
    },
  },
};
